import {Box} from "@unibuddy/patron";
import {PropsWithChildren} from "react";

export const TodoListItemWrapper = ({children}: PropsWithChildren) => {
    return (
        <Box w={400} borderWidth={1} borderRadius="small" margin="small" borderColor="grey100">
            {children}
        </Box>
    );
};
